import './SectionZeroState.scss'

import classNames from 'classnames'
import Button, { ButtonProps } from 'lib/components/Button/Button'
import { QUERY_KEYS } from 'lib/util/routing'
import React, { HTMLAttributes } from 'react'
import { useTranslation } from 'react-i18next'
import { useHistory } from 'react-router-dom'

function SectionZeroState(props: HTMLAttributes<HTMLDivElement>) {
  const { children, className, ...otherProps } = props
  const mergedClassName = classNames('section-zero-state', className)

  return (
    <div className={mergedClassName} {...otherProps}>
      {children}
    </div>
  )
}

export interface SectionZeroStateMessageProps extends HTMLAttributes<HTMLSpanElement> {
  className?: string
}

function SectionZeroStateMessage(props: SectionZeroStateMessageProps) {
  const { children, className, ...otherProps } = props
  const mergedClassName = classNames('section-zero-state__message', className)

  return (
    <span className={mergedClassName} {...otherProps}>
      {children}
    </span>
  )
}

function ClearButton(props: ButtonProps) {
  const { className, children, ...otherProps } = props
  const mergedClassName = classNames('section-zero-state__link', className)

  return (
    <Button variant="link" className={mergedClassName} {...otherProps}>
      {children}
    </Button>
  )
}

function ClearFiltersLink(props: ButtonProps) {
  const [t] = useTranslation()
  const history = useHistory()

  function onClick() {
    const params = new URLSearchParams(history.location.search)
    for (const key of [QUERY_KEYS.series, QUERY_KEYS.skill, QUERY_KEYS.start]) {
      params.delete(key)
    }
    history.push({ ...history.location, state: { ...history.location.state }, search: `?${params.toString()}` })
  }

  return (
    <ClearButton onClick={onClick} {...props}>
      {t('home.sections.zeroState.link')}
    </ClearButton>
  )
}

SectionZeroState.Message = SectionZeroStateMessage
SectionZeroState.ClearFiltersLink = ClearFiltersLink
SectionZeroState.ClearButton = ClearButton
export default SectionZeroState
